import React, { ReactNode, useState } from 'react';
import useSessionStorage from '@app/react-common/hooks/useSessionStorage';

export interface BarnnerProps {
  title: string;
  content: ReactNode;
  onBannerClosed?: () => void;
  sessionKey?: string;
  forwardedRef?: React.ForwardedRef<HTMLDivElement>;
  hideCloseButton?: boolean;
  variant?: string;
}

export const WarningBanner: React.FC<BarnnerProps> = ({
  title,
  content,
  forwardedRef = null,
  onBannerClosed = null,
  sessionKey = null,
  hideCloseButton = false,
  variant = 'attention',
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks -- TODO: refactor to avoid conditional hook call
  const [bannerClosed, setBannerClosed] = sessionKey ? useSessionStorage(sessionKey, false) : useState(false);

  if (bannerClosed) return null;

  return (
    <div className="react-banner" ref={forwardedRef}>
      <div className={`pdq-banner pdq-banner--${variant}`}>
        <div className="react-banner__header">
          <p className="title">
            <img src={`/assets/icons/banner-${variant}-icon.svg`} />
            {title}
          </p>
          {!hideCloseButton && (
            <span className="close">
              <i
                className="icon icon-close"
                onClick={() => {
                  setBannerClosed(true);
                  onBannerClosed();
                }}></i>
            </span>
          )}
        </div>
        {content}
      </div>
    </div>
  );
};
